export default {
  "/payment/withdraw": [
    {
      path: "/payPassValid/rePayPassValid",
      name: "withDrawValid",
      meta: {
        title: "验证支付密码",
        showLink: true,
        hiddenTag: true,
        matchedPath: "/payment/withdraw",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/common/result",
      name: "withRrawResult",
      meta: {
        title: "提现成功",
        hiddenTag: true,
        matchedPath: "/payment/withdraw",
        visible: "1",
        operate: "0"
      }
    }
  ],
  "/payment/paymentLog": [
    {
      path: "/payment/withDrawDetail",
      name: "withDrawDetail",
      meta: {
        title: "提现详情",
        showLink: true,
        hiddenTag: true,
        matchedPath: "/payment/paymentLog",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/payment/payOutDetail",
      name: "payOutDetail",
      meta: {
        title: "结汇付款详情",
        showLink: true,
        hiddenTag: true,
        matchedPath: "/payment/paymentLog",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/payment/foreignDetail",
      name: "foreignDetail",
      meta: {
        title: "国外付款详情",
        showLink: true,
        hiddenTag: true,
        matchedPath: "/payment/paymentLog",
        visible: "1",
        operate: "0"
      }
    }
  ],
  "/payment/payOut": [
    {
      path: "/payPassValid/rePayPassValid",
      name: "payOutValid",
      meta: {
        title: "验证支付密码",
        showLink: true,
        hiddenTag: true,
        matchedPath: "/payment/payOut",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/common/result",
      name: "payOutResult",
      meta: {
        title: "付款成功",
        hiddenTag: true,
        matchedPath: "/payment/payOut",
        visible: "1",
        operate: "0"
      }
    }
  ],
  "/payment/foreign": [
    {
      path: "/payPassValid/rePayPassValid",
      name: "foreignValid",
      meta: {
        title: "验证支付密码",
        showLink: true,
        hiddenTag: true,
        matchedPath: "/payment/foreign",
        visible: "1",
        operate: "0"
      }
    },
    {
      path: "/common/result",
      name: "foreignResult",
      meta: {
        title: "付款成功",
        hiddenTag: true,
        matchedPath: "/payment/foreign",
        visible: "1",
        operate: "0"
      }
    }
  ]
};
